import React from "react";
import { RouteComponentProps } from "@reach/router";

import Layout from "../../components/Shared/Layout";
import { MDBCard, MDBCardImage, MDBContainer, MDBRow, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn, MDBCol } from "mdbreact";
// import SEO from "../components/seo";

import "./NotFound.scss";
import ErrorIcon from "./../../assets/images/icon/404.svg";

interface NotFoundPageProps extends RouteComponentProps {
  title: string;
}

const NotFoundPage = (props: NotFoundPageProps) => (
  <Layout title={props.title}>
    <MDBContainer className="not-found">
      <MDBRow middle center>
        <MDBCol middle>
          <img className="img-fluid" src={ErrorIcon} />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  </Layout>
);

export default NotFoundPage;
